<template>
    <div>
        <div>
            <label
                for="select-contents"
                class="text-sm uppercase"
                :class="{ 'text-error': showErrors && !modelValue }"
            >
                <template v-if="familyProductTypeShortLabel">
                    {{ capitalizeFirstLetter(familyProductTypeShortLabel) }}
                </template>
                Contents
            </label>
        </div>

        <Dropdown
            id="select-contents"
            :model-value="modelValue"
            class="appearance-blocky mt-4"
            :is-errored="showErrors && !modelValue"
            :choices="contentsChoices || []"
            :placeholder="contentsChoicesPlaceholder"
            data-cy="configurator-contents"
            @update:model-value="$emit('update:model-value', $event)"
        />
    </div>
</template>

<script setup lang="ts">
import { capitalizeFirstLetter } from '~/utils/helpers';
import { ProductData } from '~/types/product';

const { portalUrl } = useRuntimeConfig().public;

defineEmits(['update:model-value']);

const props = defineProps<{
    modelValue: string | null;
    productDatas: ProductData[];
    showErrors: boolean;
}>();

const { familyProductTypeShortLabel } = useFamilyProductDataLabels(
    computed(() => props.productDatas),
);

const { data: contentsChoices } = await useFetch(
    `${portalUrl}/api/configurator/contents-choices`,
    { transform: (jsendData: any) => jsendData.data },
);

const contentsChoicesPlaceholder = computed(() => {
    let placeholder = 'Select';
    if (familyProductTypeShortLabel.value) {
        placeholder += ` ${capitalizeFirstLetter(
            familyProductTypeShortLabel.value,
        )}`;
    }
    placeholder += ' Contents';
    return placeholder;
});
</script>
